import { mapActions } from 'vuex'
import I18nKeys from 'src/utils/i18n-keys'

export default {
  ...mapActions('graphics', ['getAll']),
  setSortOrders () {
    return new Promise(resolve => {
      /**
       * Create orders from submission.
       */
      const imageSortorders = this.submissionImageSortorders
      for (const item of imageSortorders.filter(o => I18nKeys.COUNTRIES.indexOf(o.locationIso) > -1)) {
        if (!this.sortOrders.some(o => o.iso === item.locationIso)) {
          this.sortOrders.push(this.newOrder({
            blue: item.locationIso,
            monday: item.imageIds
          }))
        }
      }
      /**
       * If no order, set default.
       * Pass an array with empty id for default slide.
       */
      if (this.sortOrders.length === 0) {
        this.sortOrders.push(this.newOrder())
      }
      /**
       * Done
       */
      resolve()
    })
  },
  newOrder (options = {}) {
    /**
     * Set Options.
     * blue --> iso (String)
     * monday --> imageIds (Array)
     */
    options.blue = options.blue || this.$store.getters['settings/iso']
    options.monday = options.monday || []
    /**
     * Create a new order for sortOrders.
     * Return {Object}
     */
    return {
      iso: options.blue,
      graphics: options.monday.map(imageId => this.createGraphic({ id: imageId }))
    }
  },
  createGraphic (options = {}) {
    /**
     * Create a Object for graphics.
     * @Return {Object}
     */
    function _getGraphicId() {
      return 'graphic' + Math.floor((Math.random() * 4) * 100000000000000) //NOSONAR - it's safe here to use Math.random as it's not used for security purposes
    }
    return {
      graphicId: _getGraphicId(),
      status: options.status || 'unset',
      image: { id: options.id || null }
    }
  },
  syncGraphics () {
    return new Promise(resolve => {
      let isComplete = true
      this.sortOrders.map(o => {
        /**
         * Sync image data.
         */
        o.graphics.forEach((g, idx) => {
          const graphic = !g.image.id
            ? this.graphicsFindByGraphicId(g.graphicId)
            : this.graphicsFindByImageId(g.image.id)
          if (graphic) {
            g.image = graphic.image
            g.status = graphic.status
          }
          if (graphic && g.status !== this.graphicsStates.COMPLETE) {
            isComplete = false
          }
          if (!graphic) {
            g.status = this.graphicsStates.FAILED
          }
        })
        /**
         * Remove failed.
         */
        o.graphics = o.graphics.filter(g => g.status !== this.graphicsStates.FAILED)
      })
      if (!isComplete) {
        this.graphicsTimer.clear()
        this.graphicsTimer.set(() => {
          this.getAll({
            submissionId: this.submission.id,
            force: true
          })
        }, 2000)
      }
      resolve()
    })
  }
}
